import { UUID } from 'crypto';

export interface ImportControlModeTemplateResponseDto {
  updated: number;
  added: number;
  results: ImportResultItem[];
}

export interface ValidationErrorItem {
  message: string;
  path: string;
}

export interface ImportControlModeTemplateErrorDto {
  statusCode: number;
  message: string;
  errors: string | ValidationErrorItem[];
  path: string;
}

export interface ImportResultItem {
  name: string;
  status: string;
  id: string;
}

export enum ControlAuthorities {
  hmi,
  scada,
  calendar,
}

export enum ControlModeTemplateFieldsType {
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  SELECT = 'select',
}

export interface ControlModeTemplateSettings {
  controllerField: string;
  uiLabel: string;
  fields: ControlModeTemplateField[];
}

// main
export interface ControlModeTemplate {
  id: UUID;
  name: string;
  settings: ControlModeTemplateSettings[];
  deleted?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface IControlModeTemplateFieldsRange {
  min?: number;
  max?: number;
}

export interface IStringInputFieldBase {
  uiLabel: string;
  controllerField: string;
  type: ControlModeTemplateFieldsType.STRING;
  quickConfig: boolean;
}

export interface IStringInputFieldControlModeTemplate
  extends IStringInputFieldBase {
  defaultValue?: string;
}

export interface INumberInputFieldBase {
  uiLabel: string;
  controllerField: string;
  type: ControlModeTemplateFieldsType.NUMBER;
  range?: IControlModeTemplateFieldsRange;
  quickConfig: boolean;
}

export interface INumberInputFieldControlModeTemplate
  extends INumberInputFieldBase {
  defaultValue?: number;
}

export interface IBooleanInputFieldBase {
  uiLabel: string;
  controllerField: string;
  type: ControlModeTemplateFieldsType.BOOLEAN;
  quickConfig: boolean;
}

export interface IBooleanInputFieldControlModeTemplate
  extends IBooleanInputFieldBase {
  defaultValue?: boolean;
}

export interface ISelectInputFieldBase {
  uiLabel: string;
  controllerField: string;
  type: ControlModeTemplateFieldsType.SELECT;
  listOptions: string[];
  quickConfig: boolean;
}

export interface ISelectInputFieldControlModeTemplate
  extends ISelectInputFieldBase {
  defaultValue?: string;
}

export interface IControlModeTemplateFields {
  uiLabel: string;
  controllerField: string;
  type: string;
  range?: IControlModeTemplateFieldsRange;
  listOptions?: string[];
  defaultValue?: string | number | boolean;
  quickConfig: boolean;
}

// Combined field type
export type ControlModeTemplateField =
  | IStringInputFieldControlModeTemplate
  | INumberInputFieldControlModeTemplate
  | IBooleanInputFieldControlModeTemplate
  | ISelectInputFieldControlModeTemplate;
